import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiCustom from "../../utils/ApiCustom";

export const fetchFeedback = createAsyncThunk(
  "feedback/fetchFeedback",
  async () => {
    const response = await apiCustom.get("comment-showAll");
    return response.data?.data?.data;
  }
);

export const updateFeedback = createAsyncThunk(
  "feedback/updateFeedback",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await apiCustom.put(`/comment-approve/${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);

const feedbackSlice = createSlice({
  name: "feedbacks",
  initialState: {
    coupons: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeedback.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchFeedback.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.feedbacks = action.payload;
      })
      .addCase(fetchFeedback.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(updateFeedback.fulfilled, (state) => {
        state.status = "idle";
      });
  },
});

export default feedbackSlice.reducer;
